import {Box, Grid, Typography} from '@mui/material';
import {GetSummaryOfInProgressLoansResponse} from '../../../models/loan.model';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';

interface IInProgressLoans {
    inProgressLoans: GetSummaryOfInProgressLoansResponse[];
    handleInProgressLoans: Function;
}

const InProgressLoans = ({
    inProgressLoans,
    handleInProgressLoans,
}: IInProgressLoans) => {
    return (
        <Grid container sx={{width: '100%', borderRadius: '5px', gap: '20px'}}>
            <Grid
                item
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '10px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '5px',
                        width: '100%',
                    }}
                >
                    <Typography
                        sx={{
                            color: 'var(--primary-text-color)',
                            fontSize: '0.875rem',
                            fontWeight: 'bold',
                        }}
                    >
                        پرونده های در جریان
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                {inProgressLoans?.map((loan, index) => (
                    <Box
                        key={index}
                        onClick={() =>
                            handleInProgressLoans(
                                loan?.referenceKey,
                                loan?.loanTemplateKey
                            )
                        }
                        sx={{
                            border: '1px solid var(--border-color)',
                            backgroundColor: 'var(--input-bg-color)',
                            width: '100%',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            // , backgroundColor: loan?.hasRejectReason ? "rgba(251,228,231,0.5)" : "rgba(222,241,241,0.5)"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                            }}
                        >
                            <Box
                                sx={{
                                    height: 'fit-content',
                                    width: 'fit-content',
                                    border: '1px solid #A4A4A4',
                                    borderRadius: '8px',
                                    padding: '5px',
                                    background: '#fff',
                                }}
                            >
                                <img
                                    src={loan?.logoUrl}
                                    style={{
                                        objectFit: 'contain',
                                        width: '1.5rem',
                                        height: '1.5rem',
                                    }}
                                />
                            </Box>
                            <Typography
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'var(--primary-text-color)',
                                    fontSize: '0.875rem',
                                }}
                            >
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '0.875rem',
                                    }}
                                >
                                    {loan?.financialSupplierTitle}
                                </span>{' '}
                                <span
                                    style={{fontSize: '0.7rem', color: 'gray'}}
                                >
                                    {loan?.duration}
                                </span>
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                            }}
                        >
                            <Typography
                                className="bgSecondaryColorLight px-2 py-1 rounded"
                                sx={{fontSize: '0.7rem'}}
                            >
                                {loan?.loanRequestStatusTitle}
                            </Typography>
                            <ChevronLeftOutlinedIcon
                                sx={{fontSize: '1.5rem', color: 'gray'}}
                            />
                        </Box>
                    </Box>
                ))}
            </Grid>
        </Grid>
    );
};

export default InProgressLoans;
